'use client';

import { isMvpdAuthenticated } from '../isMvpdAuthenticated';
import { getUserInfo } from './getUserInfo';

/**
 * @returns Whether the user is only MVPD authenticated, meaning user has no FOX One identity
 */
export function isOnlyMvpdAuthenticated(): boolean {
  const { accessToken, email } = getUserInfo();

  const isOnlyMvpd = Boolean(!email && isMvpdAuthenticated(accessToken));

  return isOnlyMvpd;
}
